import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../../providers/UserProvider";
import EeljInfo from "../eelj/EeljInfo";
import { submitEelj, getOrderCheck } from "../../app/api";
import { Link } from "react-router-dom";

export const Payment = () => {
  const generateCaptcha = () => Math.random().toString(36).slice(-5);

  const { eeljuud, userBio, userOrders, fetchLoggedUserData } = useContext(UserContext);
  const nav = useNavigate();
  const { id } = useParams();
  const [agree, setAgree] = useState(false);
  const [agreeError, setAgreeError] = useState(false);
  const [serverError, setServerError] = useState<any | undefined>(undefined);
  const [orderResponse, setOrderResponse] = useState<any | undefined>(undefined);
  const [paymentStatus, setPaymentStatus] = useState<any | undefined>(undefined);
  const [orderId, setOrderId] = useState<any | undefined>(undefined);
  const [captcha, setCaptcha] = useState(generateCaptcha);
  const [captchaInput, setCaptchaInput] = useState<string>('');
  const [captchaError, setCaptchaError] = useState(false);
  const [requestLoading, setRequestLoading] = useState(false);
  const [itqpay, setItqpay] = useState<any | undefined>(undefined);

  useEffect(() => {
    fetchLoggedUserData();
  }, [fetchLoggedUserData]);
  // useEffect(() => {
  //   if(!userBio) {
  //     nav('/login');
  //   }
  // }, [userBio]);

  const checkPayment = async () => {
    const orderCheck = await getOrderCheck(orderId);
    if (orderCheck.data.paymentStatus === "Хүлээгдэж байгаа") {
      alert("Төлбөр хийгдээгүй байна.");
      return;
    }
    setPaymentStatus(orderCheck.data.paymentStatus);
  };

  const eelj = useMemo(() => {
    return [...eeljuud.activeEelj].find(e => e.id === id);
  }, [id, eeljuud]);

  useEffect(() => {
    const order = userOrders?.find((o) => o.eelj?.id === id);

    if (order) {
      setOrderId(order.id);
      setOrderResponse(order.qpayData);
      setPaymentStatus(order.paymentStatus);
      if (order.qpayDataIT) {
        setItqpay(order.qpayDataIT);
      }
    }
  }, [userOrders]);

  const handleSubmit = useCallback(async () => {
    if (!agree) {
      setAgreeError(true);
      return;
    }
    if (captcha !== captchaInput) {
      setCaptchaError(true);
      return;
    }

    setAgreeError(false);
    setCaptchaError(false);
    setServerError(undefined);
    setRequestLoading(true);
    try {
      const resp = await submitEelj(id);
      setOrderId(resp.data.id);
      setOrderResponse(resp.data.qpayData);
      setPaymentStatus(resp.data.paymentStatus);
      if (resp.data.qpayDataIT) {
        setItqpay(resp.data.qpayDataIT);
      }
    } catch (err: any) {
      if (err.response) {
        setServerError(err.response.data.error);
      } else {
        setServerError('Та түр хүлээнэ үү.');
      }
    }
    setRequestLoading(false);
    setCaptcha(generateCaptcha());
    setCaptchaInput('');
  }, [agree, captcha, captchaInput]);

  return (
    <>
      {eelj &&
        <div className="mx-auto max-w-7xl p-10 pt-[140px] flex flex-col justify-center ">
          <EeljInfo {...eelj} />
          {!orderResponse ?
            <>
              <div className="flex items-center justify-center mt-8">
                <input
                  id="link-checkbox"
                  className="mt-1 w-4 h-4 text-blue-600 bg-white border-gray-300 rounded focus:ring-blue-500 focus:ring-2  disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
                  type="checkbox"
                  defaultChecked={false}
                  onChange={(e) => { setAgree(e.target.checked) }}
                />
                <label
                  htmlFor="link-checkbox"
                  className="ml-2 text-sm font-medium text-[#001447]/60"
                >
                  Найрамдал цогцолборт амарч буй миний хүүхдийн амарч байх хугацааных нь
                  гэрэл зураг, дүрс бичлэг, аман болон дүрст ярилцлага зэргийг ОУХНЦ-ын
                  мэдээ мэдээлэл, зар сурталчилгаа, ном товхимолд хуулийн хүрээнд ашиглаж
                  болохыг би хүлээн зөвшөөрч байна.
                </label>
              </div>
              {agreeError && !agree &&
                <div className="text-red-400">Та нөхцлийг зөвшөөрнө үү.</div>
              }
              <div className="flex flex-col items-center mt-8">
                <div className="w-full min-[600px]:w-[500px] bg-[#9AAEBB1A] py-5 rounded-lg">
                  <p className="text-[#003463] text-[42px] text-center font-bold select-none">
                    {captcha}
                  </p>
                </div>
                <label className="w-full min-[600px]:w-[500px] mt-4">
                  <span className="text-gray-700">Та дээрх кодыг оруулна уу</span>
                  <input
                    required={true}
                    className="mt-1 block text-[#001447] w-full rounded-2xl border-[#001447]/20 disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
                    type="text"
                    value={captchaInput}
                    onChange={(e) => {
                      setCaptchaError(false);
                      setCaptchaInput(e.target.value);
                    }}
                  />
                </label>
                {captchaError && <span className="text-red-300">Та дээрх кодыг зөв оруулна уу</span>}

                {requestLoading ?
                  <div className="mt-4 px-7 py-3 rounded-3xl bg-gray-100 text-black font-bold cursor-pointer">
                    Захиалж байна
                  </div>
                  :
                  <div onClick={(e) => { e.preventDefault(); handleSubmit() }} className="mt-4 px-7 py-3 rounded-3xl bg-gradient-to-r from-[#07B2EC] to-[#419CE8] text-white font-bold cursor-pointer">
                    QPay-ээр худалдан авах
                  </div>
                }
              </div>
            </>
            :
            <>
              {paymentStatus === "Төлсөн" ?


                <div className="mx-auto max-w-7xl p-10 flex flex-col justify-center ">
                  <p>Төлбөр амжилттай хийгдлээ.</p>
                  <Link to={'/profile'} target="_blank" className="underline text-green-600">Та профайл хэсэг рүү орж татаж аваарай.</Link>
                </div> :
                eelj?.tulburdaraaavah ? (
                  <div className="mx-auto max-w-7xl p-10 flex flex-col justify-center text-center">
                    <p className="text-lg font-semibold text-[#001447]">
                      Та амжилттай бүртгүүллээ төлбөрийг 1 сард авах болно
                    </p>
                  </div>
                ) : (
                  <div className="mx-auto max-w-7xl p-10 flex-col justify-center text-center">
                    {itqpay ? <p>Та доорх 2 QR кодоор төлбөрөө төлнө үү.
                      Найрамдалын төлбөр болон Програмчлалын хөтөлбөрийн төлбөр тусдаа төлөгдөнө.
                    </p>
                      : <p>Та доорх QR кодоор төлбөрөө төлнө үү.</p>}
                    <img src={`data:image/png;base64, ${orderResponse.qr_image}`}
                      style={{ display: 'block', margin: '0 auto', maxWidth: '100%', height: 'auto' }}
                    />
                    <a href={orderResponse.qPay_shortUrl} target="_blank" className="underline text-green-600">Аппликэйшнээр төлөх бол энд дарна уу.</a>
                    <br />

                    {
                      itqpay &&
                      <>
                        <p>Та доорх QR кодоор Програмчлалын хөтөлбөрийн төлбөрөө төлнө үү.</p>
                        <img src={`data:image/png;base64, ${itqpay.qr_image}`}
                          style={{ display: 'block', margin: '0 auto', maxWidth: '100%', height: 'auto' }}
                        />
                        <a href={itqpay.qPay_shortUrl} target="_blank" className="underline text-green-600">Аппликэйшнээр төлөх бол энд дарна уу.</a>
                        <br />
                      </>
                    }

                    <div className="w-full flex justify-center mt-2">

                      <div onClick={checkPayment} className="w-[200px] text-center mt-2 rounded-full  px-3.5 py-2.5 text-sm font-semibold text-[white] cursor-pointer" style={{ background: "rgb(7, 178, 236)" }}>
                        Төлбөр шалгах
                      </div>
                    </div>

                  </div>
                )

              }
            </>
          }
          {serverError &&
            <div className="text-red-400">Алдаа: {JSON.stringify(serverError)}</div>
          }
        </div>
      }
    </>
  );
}

export default Payment;